import classnames from 'classnames';
import Error from './Error';
import Label from './Label';
import type { FormError } from './types';

interface TextareaProps {
  characterCount?: number | null;
  characterLimit?: number | null;
  error?: FormError | null;
  label?: string;
  name: string;
  placeholder?: string;
  register: object;
  rows?: number;
  testId?: string;
}

const Textarea = ({
  characterCount = null,
  characterLimit = null,
  error = null,
  label,
  name,
  placeholder = '',
  register,
  rows = 3,
  testId = '',
}: TextareaProps) => (
  <div className="form-group">
    {label && <Label name={name}>{label}</Label>}
    <textarea
      aria-label={label ?? name}
      className={classnames('form-control', { 'is-invalid': error })}
      data-testid={testId}
      id={name}
      placeholder={placeholder}
      rows={rows}
      {...register}
    />
    {characterLimit !== null && characterCount !== null && (
      <div
        className={classnames('d-flex justify-content-end pt-1 text-0_875', {
          'text-danger': characterCount > characterLimit,
        })}
      >
        {characterCount} / {characterLimit}
      </div>
    )}
    <Error>{error?.message}</Error>
  </div>
);

export default Textarea;
